










import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { QueryUserActivityRecordList } from '@/api'
import constant from '@/utils/constant'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { DateFormat } from '@/utils/date/DateUtil'

@Component({
  components: {
    VQuery,
    VTable,
  },
})
export default class UserActivityRecordDialog extends Vue {
  @Prop({ type: Boolean, default: false }) private appendToBody!: boolean

  @Emit('close')
  private close() {
    this.show = false
    this.queryParam = {
      startRow: 1,
      limit: 10,
      orderBy: 'create_time desc , id desc',
      wayType: undefined,
      createTimeDaterange: [],
    }
  }

  private data: any = {}
  private show = false

  public open(data: any) {
    this.show = true
    this.data = data || {}
    this.queryParam = {
      startRow: 1,
      limit: 10,
      orderBy: 'create_time desc , id desc',
      wayType: undefined,
      createTimeDaterange: [],
    }
    this.tableCurrntPage = 1
    this.loadData()
  }

  private queryParam: any = {
    startRow: 1,
    limit: 10,
    orderBy: 'create_time desc , id desc',
    wayType: undefined,
    createTimeDaterange: [],
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  private queryModels: Array<QueryModel> = [
    { title: '来源', param: 'wayType', type: 'select', selectData: constant.UserActivityWayType },
    { title: '创建时间', param: 'createTimeDaterange', type: 'daterange' },
  ]

  private queryOperation: Array<TableOperation> = []

  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '活跃变动', param: 'qty' },
    { title: '来源', param: 'wayTypeName', width: 160, overflow: true },
    { title: '业务号', param: 'recordNo', width: 220, overflow: true },
    { title: '创建时间', width: 160, param: 'createTime', formatter: DateFormat },
    { title: '备注', param: 'note', overflow: true },
  ]

  public async loadData() {
    const param = this.getRequestParam()
    const result = await QueryUserActivityRecordList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  private getRequestParam() {
    const param: any = { ...this.queryParam }
    if (this.data.userId) {
      param.userId = this.data.userId
    }
    if (param.createTimeDaterange && param.createTimeDaterange.length > 0) {
      param.createTimes = DateFormat(param.createTimeDaterange[0]) + ',' + DateFormat(param.createTimeDaterange[1])
    }
    param.startRow = (this.tableCurrntPage - 1) * (param.limit || 12)
    return param
  }

  public search() {
    this.tableCurrntPage = 1
    this.loadData()
  }

  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
}
